import React from "react";

const initiatives = [
  {
    title: "Literacy & Education",
    description:
      "Conducting educational campaigns and distributing learning materials and stationery.",
  },
  {
    title: "Hunger Eradication",
    description:
      "Running food distribution and nourishment drives for those in need, including steady support to affected areas.",
  },
  {
    title: "Healthcare",
    description: "Organizing variety of drives including wellness drives.",
  },
  {
    title: "Child Development",
    description:
      "Supporting education, creativity, values, and overall growth of underprivileged children.",
  },
  {
    title: "Women Empowerment",
    description:
      "Driving awareness and skill development initiatives for women’s independence, dignity, defence, health.",
  },
  {
    title: "Environmental Action",
    description:
      "Leading cleanliness and plantation drives while encouraging personal growth through interactive sessions and workshops.",
  },
];

const InitiativeCards = () => {
  return (
    <section className="py-12 px-4 sm:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
            What do we do
          </h1>
        </div>
        <div className="text-lg text-center text-gray-700">
          In the <strong>2023-24 tenure</strong>,{" "}
          <strong>Leo District 321-A2</strong> proudly impacted over{" "}
          <strong>25,000 lives</strong> through{" "}
          <strong>35+ service activities</strong> across{" "}
          <strong>3 countries</strong>, in collaboration with{" "}
          <strong>20+ organizations</strong>.
          <br />
          <br />
          From educational empowerment and health awareness to winter relief and
          blood donation, the district touched communities in meaningful ways.
          Noteworthy achievements include distributing over{" "}
          <strong>700 warm clothing items</strong> benefiting{" "}
          <strong>3,200+ individuals</strong>, conducting blood donation camps
          engaging <strong>700+ participants</strong> and collecting{" "}
          <strong>464 units, educating 100+ underprivileged children</strong>{" "}
          through Akshar under Project Dhruvtara.
          <br />
          <br />
          Project Parindey has empowered{" "}
          <strong>150+ women through impactful initiatives</strong> such as
          menstrual hygiene awareness, pad distribution drives and breast cancer
          awareness. Another key initiative, Project Vitt Vichar(VV), made
          significant strides in financial empowerment—organizing impactful
          sessions that equipped a total of
          <strong> 380+ individuals</strong> with essential knowledge on{" "}
          <strong>budgeting, saving, and investments</strong>, in schools and
          colleges and conducted free financial literacy workshops for{" "}
          <strong>40+ underprivileged women of NGO Lakshyam</strong>.These
          numbers reflect a year of compassionate service and powerful community
          engagement.
        </div>
      </div>
    </section>
  );
};

export default InitiativeCards;
